export default __webpack_public_path__ + "static/media/otherreport.e626c20f.svg";